import { useCallback, useRef } from 'react';

/**
 * Utility Hook: Debounces a Promise-returning function.
 * Prevents the API from being spammed on every single keystroke.
 */
export default function useDebouncedPromise<T>(
  func: ((inputValue: string) => Promise<T>) | undefined,
  wait: number,
) {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  return useCallback(
    (inputValue: string) => {
      if (!func) return Promise.resolve([] as unknown as T);

      return new Promise<T>((resolve) => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => {
          resolve(func(inputValue));
        }, wait);
      });
    },
    [func, wait],
  );
}
